<template>
    <div class="checkbox-detail">      
        <div class="title">{{detail.title}}</div>
        <ul class="checkbox-main">
            <li class="checkbox-container" v-for="(item, index) in detail.list" :key="index">
                <div class="checkbox" @click="checkboxToggle(index, item)">
                    <img v-if="arrayActive[index] === true" src="@/assets/campaignlist/checkmenu_active.svg" alt="">
                    <img v-else src="@/assets/campaignlist/checkmenu_inactive.svg" alt="">
                    <div class="item-name">{{item.name}}</div>
                </div>
                <div class="item-price">+{{item.price}}</div>
            </li>
        </ul>
        <div class="check">{{check}}</div>            
    </div>
</template>

<script>
export default ({
    name: "CheckboxDetail",
    props: {
        detail: Object
    },
    data: function() {
        return{
            check: true,
            arrayActive: []
        }
    },
    created() {
        if(this.detail) {
            for(let i = 0; i < this.detail.list.length; i++){
                this.arrayActive.push(false)
            }
        }
    },
    methods: {
        checkboxToggle(index, item){
            this.arrayActive[index] = !this.arrayActive[index];
            this.check = !this.check
            if(this.arrayActive[index]) {
                this.$emit('add', item);
            } else {
                this.$emit('remove', item);
            }
        }
    },
})
</script>

<style lang="scss" scoped>
.checkbox-detail{
    background-color: rgba($color: #fff, $alpha: 0.2);
    border-radius: 15px;
    padding: 10px 15px;
    .checkbox-main{
        padding: 0;
        margin: 0;
        margin-bottom: 10px;
        .checkbox-container{
            display: flex;
            list-style: none;
            justify-content: space-between;
            align-items: center;
            margin-top: 15px;
            
            .checkbox{
                display: flex;
                img{
                    height: 24px;
                    margin-right: 15px;
                }
            }
        }
    }
    .check{
        display: none;
    }
}
</style>
